import { useVisibleObjectIds } from '@/hooks/useVisibleObjectIds';
import { ObjectView } from '@/components/objects/ObjectView';

/**
 * Object renderer: mounts one `ObjectView` per culled-visible object. Each view
 * subscribes to its own record, so this layer re-renders only when the visible set
 * changes, and a view re-renders only when its object changes.
 */
export const ObjectLayer = () => {
  const ids = useVisibleObjectIds();
  return (
    <>
      {ids.map((id) => (
        <ObjectView key={id} id={id} />
      ))}
    </>
  );
};
